import {
  TEntityResponse,
  TEntityListResponse,
  TRefreshTokenResBody,
  TRefreshTokenSummaryResBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TRefreshTokensClient = {
  revoke(id: string): Promise<void>;
  get(id: string): Promise<TEntityResponse<'refresh-token', TRefreshTokenResBody> | undefined>;
  list(
    limit: number,
    page: number
  ): Promise<TEntityListResponse<'refresh-token', TRefreshTokenSummaryResBody> | undefined>;
};

function RefreshTokensClient(apiClient: TAPIClient): TRefreshTokensClient {
  return {
    async revoke(id: string): Promise<void> {
      return await apiClient.delete(`/refresh-tokens/${id}`);
    },

    async get(id: string): Promise<TEntityResponse<'refresh-token', TRefreshTokenResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'refresh-token', TRefreshTokenResBody>>(`/refresh-tokens/${id}`);

      if (data && data.type !== 'refresh-token') {
        throw new Error('Invalid entity type received, expected: refresh-token, received: ' + data.type);
      }

      return data;
    },

    async list(
      limit: number,
      page: number
    ): Promise<TEntityListResponse<'refresh-token', TRefreshTokenSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'refresh-token', TRefreshTokenSummaryResBody>>(
        `/refresh-tokens?sort[created_at]=desc&limit=${limit}&page=${page}`
      );

      if (data && data.type !== 'refresh-token') {
        throw new Error('Invalid entity type received, expected: refresh-token, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TRefreshTokensClient, RefreshTokensClient };
